module.exports = __webpack_public_path__ + "img/secclogo.0dfd6b93.png";